<template>
    <div v-if="pivotData.length > 0">
        <vue-pivottable-ui
            :data="pivotData"
            aggregatorName='Sum'
            rendererName='Table Heatmap'
            :rows="rows"
            :cols="cols"
            :vals="vals"
        >
        </vue-pivottable-ui>
    </div>
</template>

<script>
import {VuePivottable, VuePivottableUi} from 'vue-pivottable'
import 'vue-pivottable/dist/vue-pivottable.css'
import axios from 'axios'

export default {

    data: () => ({
        pivotData: [],
        aggregatorName: 'Sum',
        rendererName: 'Table Heatmap',
        rows: ['Uploader'],
        cols: [],
        vals: ['Turnover Potential'],
        disabledFromDragDrop: [],
        hiddenFromDragDrop: []
    }),
    mounted() {
        axios.get('/api/sandoz/assortment_analysis/' + this.$route.params.id + '/pivot').then((response) => {
            this.pivotData = response.data.data
        })
    },
    methods: {
        toggle: function (todo) {
            todo.done = !todo.done
        }
    },
    components: {
        VuePivottable,
        VuePivottableUi
    }
}
</script>
